import { Component, Input } from '@angular/core';
import { ChurchInformation } from 'src/app/church';

@Component({
  selector: 'app-mass',
  templateUrl: './mass.component.html',
  styleUrls: ['./mass.component.css']
})
export class MassComponent {

  closedByDate: Map<string, boolean> = new Map();

  @Input() church: ChurchInformation = new ChurchInformation();

  constructor() {
  }

  isExpanded(date: string) {
    return !(this.closedByDate.get(date));
  }

  toggle(date: string) {
    this.closedByDate.set(date, !this.closedByDate.get(date));
  }
}
